import { Button, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ComplainModalContainer.css';

interface IComplainModalErrorProps {
  isLoading: boolean;
  onRetry(): void;
}

export const ComplainModalError = ({ isLoading, onRetry }: IComplainModalErrorProps) => (
  <div className={styles['error']}>
    <UIText2>Возможно, проблема с интернет-соединением. Попробуйте ещё раз</UIText2>
    <div className={styles['refresh']}>
      <Button disabled={isLoading} loading={isLoading} size="XS" onClick={onRetry}>
        Обновить
      </Button>
    </div>
  </div>
);
